<template>
  <div>
    <b-form @submit.prevent>
      <b-row>

        <b-col cols="12">
          <b-form-group
              label="ID"
              label-for="vi-id"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="BookIcon" />
              </b-input-group-prepend>
              <b-form-input
                  id="vi-id"
                  v-model="book.id"
                  placeholder="Id"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group
              label="Title"
              label-for="vi-title"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="BookIcon" />
              </b-input-group-prepend>
              <b-form-input
                  id="vi-title"
                  v-model="book.title"
                  placeholder="Title"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group
              label="Section ID"
              label-for="vi-section"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="BookIcon" />
              </b-input-group-prepend>
              <b-form-input
                  id="vi-title"
                  v-model="book.section_id"
                  placeholder="Section ID"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group
              label="Volume"
              label-for="vi-volume"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="BookIcon" />
              </b-input-group-prepend>
              <b-form-input
                  id="vi-title"
                  v-model="book.volume"
                  placeholder="Volume"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group
              label="Author"
              label-for="vi-author"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-input
                  id="vi-author"
                  v-model="book.author"
                  placeholder="Author"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group
              label="Path"
              label-for="vi-path"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="LinkIcon" />
              </b-input-group-prepend>
              <b-form-input
                  id="vi-path"
                  v-model="book.path"
                  placeholder="Path"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group
              label="Icon"
              label-for="vi-path"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="LinkIcon" />
              </b-input-group-prepend>
              <b-form-input
                  id="vi-icon"
                  v-model="book.icon"
                  placeholder="Icon"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <img :src="book.icon" style="margin-bottom: 10px"/>
        </b-col>

        <b-col cols="12">
          <b-form-group
              label="Date Uploaded"
              label-for="vi-uploaded"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UploadIcon" />
              </b-input-group-prepend>
              <b-form-input
                  id="vi-title"
                  v-model="book.dateUploaded"
                  placeholder="Date Uploaded"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- reset and submit -->
        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            @click="saveBook"
          >
            Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import axios from 'axios'
import firebase from 'firebase/app'
import 'firebase/auth'
import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BInputGroup, BInputGroupPrepend,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      book: {},
    }
  },
  mounted() {
  },
  methods: {
    saveBook() {
      const url = `${this.$readerURL}/admin/cpbooks`
      this.loader('block')
      firebase.auth().currentUser.getIdToken(false).then(idToken => {
        axios.post(url, this.book,
          {
            headers: {
              Authorization: idToken,
            },
          }).then(response => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'success',
              icon: 'EditIcon',
              variant: 'success',
            },
          })

          this.$router.push('/cpbooks')
          return response
        }).catch(error => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error,
              icon: 'EditIcon',
              variant: 'error',
            },
          })
        })
      })
    },
  },
}
</script>
